<div class="help-page">
  <!-- Hero Section -->
  <section class="hero-panel">
    <div class="hero-copy-wrap">
      <p class="eyebrow">Support Resources</p>
      <h1>How can we help?</h1>
      <p class="hero-copy">
        Choose a quick reference, open the full guide, or contact the Lenexa Medical team for specialized support and training.
      </p>
    </div>
  </section>

  <!-- Resource Cards Grid -->
  <section class="resource-grid">
    <article class="resource-card" *ngFor="let document of documents">
      <div class="card-thumb" aria-hidden="true">
        <img class="card-thumb-image" [src]="document.previewImage" [alt]="document.title + ' preview'" />
        <span class="card-thumb-badge">PDF</span>
      </div>
      <div class="card-content">
        <h2>{{ document.title }}</h2>
        <p class="card-copy">{{ document.description }}</p>
      </div>

      <div class="document-actions">
        <button class="document-btn btn-primary" (click)="openDocument(document)">Open Preview</button>
        <a class="document-btn btn-secondary" [href]="document.url" download (click)="$event.stopPropagation()">Download</a>
      </div>
    </article>
  </section>

  <!-- Contact support Section -->
  <section class="contact-section">
    <div class="contact-header">
      <h2>Still need assistance?</h2>
      <p>Our specialized support team is available for technical help, clinical training, or follow-up support.</p>
    </div>

    <div class="contact-grid">
      <div class="contact-card-item">
        <div class="icon-wrapper">
          <mat-icon>mail_outline</mat-icon>
        </div>
        <h3>Email Support</h3>
        <a href="mailto:{{ contact.email }}">{{ contact.email }}</a>
      </div>

      <div class="contact-card-item">
        <div class="icon-wrapper">
          <mat-icon>phone</mat-icon>
        </div>
        <h3>24/7 Support Line</h3>
        <a href="tel:{{ contact.phone.replace(' ', '') }}">{{ contact.phone }}</a>
      </div>

      <div class="contact-card-item">
        <div class="icon-wrapper">
          <mat-icon>phone_callback</mat-icon>
        </div>
        <h3>Request Callback</h3>
        <button class="callback-trigger-btn" (click)="openCallbackDialog()">Get a Callback</button>
      </div>
    </div>
  </section>
</div>
